// Candidate bilingual entries for the analytics detail capture batch.
import type { ProductImageEntry } from "./types";

const entry = (
  id: string,
  module: string,
  opens: string,
  setup: readonly string[],
  altSv: string,
  altEn: string,
  showsSv: string,
  showsEn: string,
  provesSv: string,
  provesEn: string,
): ProductImageEntry => ({
  id,
  module,
  area: id.startsWith("planning.") ? "schedule" : "solution",
  opens,
  setup,
  scenario: "S1",
  visual: { variant: 0 },
  text: {
    sv: { alt: altSv, shows: showsSv, proves: provesSv },
    en: { alt: altEn, shows: showsEn, proves: provesEn },
  },
  use: ["pages/Plattform.tsx"],
});

const savedAnalysis = "Schema → Analys → sparat DEV-resultat";

export const ANALYTICS_NEXT_CANDIDATE_CATALOGUE: readonly ProductImageEntry[] =
  [
    entry(
      "analytics.lead.luckor-chart",
      "Analys · Luckor",
      `${savedAnalysis} → Otilldelade → Luckor`,
      [
        "Öppna sparat färdigt DEV-resultat",
        "Visa hela Luckor-diagrammet och dess periodvärden",
      ],
      "Luckor-diagram med summering för den valda lösningen",
      "Unassigned-demand chart with a summary for the selected solution",
      "Diagrammet visar dagarnas fördelning och den valda periodens summering.",
      "The chart shows the daily distribution and the selected period summary.",
      "Staplar, period och summering kommer från lösningens coverage-data.",
      "Bars, period and summary come from the solution's coverage data.",
    ),
    entry(
      "analytics.lead.idle-wait-list",
      "Analys · Ledig tid och väntan",
      `${savedAnalysis} → Otilldelade → Ledig tid och väntan`,
      [
        "Öppna sparat färdigt DEV-resultat",
        "Rulla listan in i bild så dess mätning laddas",
      ],
      "Rangordnad lista med positiv ledig tid och väntan per medarbetare",
      "Ranked list of positive idle and waiting time by employee",
      "Listan visar medarbetare och deras mätta lediga tid och väntan.",
      "The list shows employees and their measured idle and waiting time.",
      "Rangordningen bygger på lösningens uppmätta idle- och wait-rader.",
      "The ranking uses the solution's measured idle and wait rows.",
    ),
    entry(
      "analytics.lead.continuity-spread",
      "Analys · Kontinuitet",
      `${savedAnalysis} → Översikt → öppna kontinuitetsfördelningen`,
      [
        "Öppna sparat färdigt DEV-resultat med tillgänglig itinerary",
        "Öppna detaljen om brukare med många medarbetare",
      ],
      "Kontinuitetsfördelning över gränserna tio och femton medarbetare",
      "Continuity spread above the ten and fifteen caregiver thresholds",
      "Detaljen räknar brukare över två kontinuitetsgränser.",
      "The detail counts clients above two continuity thresholds.",
      "Antalen kommer från lösningens brukarspecifika kontinuitetsmått.",
      "Counts come from the solution's client-level continuity measures.",
    ),
    entry(
      "analytics.lead.comparison-summary",
      "Analys · Jämförelse",
      `${savedAnalysis} → välj CAIRE mot BASIC`,
      [
        "Öppna sparat färdigt DEV-resultat och ett separat färdigt BASIC-resultat",
        "Välj BASIC som explicit jämförelse; båda lösningarna behöver läsbara mått",
      ],
      "Jämförelse av tilldelning, brukartid, kontinuitet och restid",
      "Comparison of assignments, client time, continuity and travel time",
      "Sammanfattningen visar fyra mått för lösningen och den valda referensen.",
      "The summary shows four measures for the solution and selected reference.",
      "Båda sidornas värden kommer från samma explicita lösningspar.",
      "Values on both sides come from the same explicit solution pair.",
    ),
    entry(
      "planning.calendar.highlights-pinned",
      "Planering · Kalenderinsikter",
      "Schema → Kalender → vald lösning → Viktigast just nu under kalendern",
      [
        "Öppna kalendern för sparat färdigt DEV-resultat",
        "Välj dagsvy och öppna kalenderns insiktsrad",
        "Fortsätt endast om den riktiga kalenderläsningen returnerar minst ett fynd",
      ],
      "Riktiga analysfynd fästa under kalenderns dagsvy",
      "Actual analysis findings pinned below the calendar day view",
      "Kalendern visar fynd som hör till den valda lösningens dag.",
      "The calendar shows findings for the selected solution's day.",
      "Fynden kommer från kalenderns riktiga lösnings- och dagsläsningar.",
      "Findings come from the calendar's real solution and day reads.",
    ),
  ];
